require('./insurancePdfViewerError.scss');

//@vendor
const React = require('react');
const PropTypes = require('prop-types');

// @core
const { FormattedText } = require('core/i18n').i18n;

//@commons
const { OKButton } = require('components/commons/OKButton/OKButton');

const InsurancePdfViewerError = (props) => {

    const poeditorPrefix = 'insuranceLegalDocumentsError';

    const handleButtonClick = () => {
        props.getDocuments();
    }

    return (
        <div className="insurance-pdf-viewer-error">
            <i className="insurance-pdf-viewer-error__icon-error" />
            <span className="insurance-pdf-viewer-error__message">
                <FormattedText value={`${poeditorPrefix}-${poeditorPrefix}_legalDocumentsFirstErrorMessage`} />
            </span>
            <span className="insurance-pdf-viewer-error__message">
                <FormattedText value={`${poeditorPrefix}-${poeditorPrefix}_legalDocumentsSecondErrorMessage`} />
            </span>
            <div className="insurance-pdf-viewer-error__button">
                <OKButton
                    onClick={handleButtonClick}
                    modifier="secondary"
                >
                    <FormattedText value={`${poeditorPrefix}-${poeditorPrefix}_legalDocumentsButtonErrorText`} />
                </OKButton>
            </div>
            <span className="insurance-pdf-viewer-error__contact-message">
                <FormattedText value={`${poeditorPrefix}-${poeditorPrefix}_legalDocumentsContactMessage`} />
                <span className="insurance-pdf-viewer-error__contact-number">
                    <FormattedText value={`${poeditorPrefix}-${poeditorPrefix}_legalDocumentsContactNumber`} />
                </span>
            </span>
        </div>
    );
};

InsurancePdfViewerError.propTypes = {
    getDocuments: PropTypes.func.isRequired
};

module.exports = InsurancePdfViewerError;
